(function() {
    'use strict';

    angular
        .module('iseekApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
